export default __webpack_public_path__ + "static/media/logo-white.57cf78a3.svg";